import { Box } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { SamplingStatsCard } from '../../components/sampling-stats-card/sampling-stats-card';
import { dashboardQueries } from '../../data-access/queries/dashboard.queries';

import { PageError } from './page.error';
import { PendingPage } from './page.pending';

import { useQueriesWithGlobal } from '@data-access';
import { CommonError } from '@ui';

export function DashboardPage() {
  const { t } = useTranslation();
  const queries = useQueriesWithGlobal(dashboardQueries);
  const samplingStats = useQuery(queries.samplingStats());

  if (samplingStats.isPending) {
    return <PendingPage />;
  }

  if (samplingStats.isError) {
    return (
      <Box p="md">
        <CommonError
          description={t('common.error.pageError')}
          error={samplingStats.error}
          reset={() => {
            void samplingStats.refetch();
          }}
        />
      </Box>
    );
  }

  if (!samplingStats.data) {
    return <PendingPage />;
  }

  return <SamplingStatsCard stats={samplingStats.data} />;
}

DashboardPage.Error = PageError;
DashboardPage.Pending = PendingPage;

export default DashboardPage;
